import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { POST } from "../../utils/api";
import { API } from "../../endpoints/common_endpoints";


export const careerForm = createAsyncThunk("career/apply", async (data, { rejectWithValue }) => {
  try {
    const response = await POST(API.CAREER_FORM, data);
    if (response?.success) return response;
    return rejectWithValue(response?.message || "Could not send your application");
  } catch (error) {
    return rejectWithValue(error.message || "Could not send your application");
  }
});

const careerformSlice = createSlice({
  name: "careerform",
  initialState: { status: "idle", error: null, message: "" },
  reducers: {
    resetCareerForm: () => ({ status: "idle", error: null, message: "" }),
  },
  extraReducers: (builder) => {
    builder
      .addCase(careerForm.pending, (s) => { s.status = "loading"; s.error = null; })
      .addCase(careerForm.fulfilled, (s, a) => { s.status = "succeeded"; s.message = a.payload?.message || "Application sent"; })
      .addCase(careerForm.rejected, (s, a) => { s.status = "failed"; s.error = a.payload || "Could not send your application"; });
  },
});

export const { resetCareerForm } = careerformSlice.actions;
export default careerformSlice.reducer;